var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',{staticClass:"display-1 font-weight-bold px-3"},[_vm._v("Edit Your Profile")]),_c('sign-on',{attrs:{"edit":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }